import { Component } from 'react';
import Timepicker from '../../Input/Timepicker';
import { floatToTime, timeToFloat } from '../../../time'
import { TYPING_TIMEOUT } from '../../../constants'
import moment from 'moment'
import { getCurrentFunctionName } from '../../../performanceModeManager';

class InterventionTimePicker extends Component {

    state = {
        timeout: TYPING_TIMEOUT,
    }

    handleChange(value) {
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        this.setState({
            typingTimeout: setTimeout(() => {
                let date = new Date(value);

                if (!date) {
                    console.error("L'heure sélectionnée est invalide");
                    return
                }

                let fieldValue = this.props.value;

                if (this.props.interval)
                    date = this.roundToSuperiorInterval(moment(value)).toDate()

                fieldValue.value_float = timeToFloat(date.getHours(), date.getMinutes());

                this.props.fieldValueChange(fieldValue);
            }, this.state.timeout)
        });
    }

    roundToSuperiorInterval(value) {
        const interval = this.props.interval
        const remainder = interval - (value.minute() % interval);

        if (remainder !== interval)
            return moment(value).add(remainder, "minutes");
        else
            return moment(value)
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        return (
            <div className="control-margin-top">
                <Timepicker
                    id="intervention-time-picker"
                    mode="24h"
                    label={this.props.model.name}
                    showToolbar
                    {...this.props.inputProperties}
                    value={this.props.value.value_float ? floatToTime(this.props.value.value_float) : undefined}
                    onChange={this.handleChange.bind(this)}
                    className={this.props.inputProperties.className + " full_size control-margin-top " + (this.props.inputProperties.disabled ? "light-disabled" : "")}
                />
            </div>
        )
    }
}

export default InterventionTimePicker;
